var router = require('pjax').Router;
var form = require('./form.js');
var index = require('./index.js');

router.get('export', index);
router.get('export/:any', form);
